<template>
  <div class="content-wrapper remove_table_shadow">

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <div
      class="card card-with-search border-0 card-with-shadow d-none"
      v-for="(item, index) in packages"
      :key="index"
    >
      <div
        class="
          card-header
          d-flex
          justify-content-between
          align-items-center
          p-primary
          bg-transparent
        "
      >
        <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
      </div>
      <div class="card-body">
        <div class="text-justify" v-for="inc in item.include" :key="inc">
          {{ inc }}
        </div>
      </div>

      <app-button
        :label="$t('purchase_now')"
        class-name="btn-success mr-2"
        :is-disabled="false"
        @submit="btnSubmit(item.id)"
      />
    </div>

    <packages-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
    <certificate-detail-view-modal
      v-if="isViewModalActive"
      :detail="certificateDetail"
      @close-modal="closeViewModal"
    />
    <certificate-description-modal
      v-if="isDescriptionModalActive"
      :detail="descriptionDetail"
      @close-modal="closeDescriptionModal"
    />

    <!-- This modal is use for both condition 1-certificate assign to user 2-User request for training  -->
    <!-- Table show condition wise 1- If tarining assign to any user show user list -->
    <!-- 2- If request for training any user show user list -->
    <certificate-listing-modal
      v-if="showUserListingModal"
      :user_id="userId"
      :certificateId="certificate_id"
      :type="'issue-certificate-to-user'"
      @close-modal="closeListingModal"
  />

    <!-- <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        /> -->
  </div>
</template>

<script>
import * as actions from "@/app/Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import { TableHelpers } from "@Views/Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosPost } from "@/app/Helpers/AxiosHelper";
import AppFunction from "@/core/helpers/app/AppFunction";
import CertificateDescriptionModal from "./CertificateDescriptionModal.vue";


export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  components: {
    CertificateDescriptionModal,
  },
  props: {
    applicationType: {type :'text'},
    certificateType: {type :'text'},
  },
  data() {
    return {
      isDescriptionModalActive: false,
      descriptionDetail: {},
      showUserListingModal: false,
      certificate_id: null,
      isViewModalActive: false,
      certificateDetail: {},
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "certificate-listing-table",
      rowData: {},
      input: {},
      options: {
        name: "CertificateListingTable",
        url: this.$attrs['props'].certificateType === 'trainingCertificates'
          ? actions.COMPANY_CERTIFICATE_LIST + '?type=employee_certification&owned_only=1'
          : actions.ADMIN_CERTIFICATE + '?type=' + this.$attrs['props'].certificateType,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("title"),
          //   type: "custom-html",
          //   key: "title",
          //   modifier: (value,row) => {
          //     return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value)}</a>`;

          //     // return `<span>${this.$t(value)}</span>`;
          //   },
          // },
          {
              title: this.$t('title'),
              type: 'media-object',
              key: 'media-object',
              mediaTitleKey: 'display_title',
              // mediaSubtitleKey: 'amount',
              default: AppFunction.getAppUrl('images/bannerlayout.png'),
              modifier: (value, row) => {
                  return AppFunction.getAppUrl(row.logo ?? 'images/bannerlayout.png'); // imag url
              },
              isVisible: true
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value, row) => {
              const triggerId = `certificate-description-${row.id}`;
              this.bindDescriptionTrigger(triggerId, row);
              return `<button type="button" id="${triggerId}" class="btn btn-link p-0">${this.$t("view")}</button>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "certificate_status",
            isVisible: true,
            modifier: (value) => {
              if (value != null) {
                let ClassName = "warning";
                const normalizedStatus = (value.status || "").toLowerCase();

                if (["accepted", "passed", "completed", "enrolled"].includes(normalizedStatus)) ClassName = `success`;
                else if (value.status === "rejected") ClassName = `danger`;

                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  value.status
                )}</span>`;
              }
            },
          },
          {
            title: this.$t("access"),
            type: "custom-html",
            key: "pricing_type",
            isVisible: this.$attrs['props'].certificateType === 'trainingCertificates',
            modifier: (value, row) => {
              return `<span class="badge badge-sm badge-pill badge-${row.pricing_type === 'credit_based' ? 'warning' : 'success'}">${row.pricing_type === 'credit_based' ? `${row.credit_usage} Credits Required` : 'Free'}</span>`;
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("apply"),
            icon: "bookmark",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions()
  },
  computed: {
    isCompanyAdmin() {
      return this.$store.state.user.loggedInUser.is_company_admin;
    }
  },
  mounted() {
    // this.getPackages();

    if(this.$attrs['props'].certificateType == 'trainingCertificates' && this.isCompanyAdmin === 1) {
      var newAction = {
            title: this.$t("assign_trainings_to_user"),
            icon: "bookmark",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          };
      this.options.actions.push(newAction);
    }
    setTimeout(() => {
      $(
        ".remove_table_shadow .h-100 .datatable .table-responsive "
      ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.searchAndSelectFilterOptions()
      this.reSetData();
    },
    closeViewModal() {
      $("#view-detail-Modal").modal("hide");
      this.isViewModalActive = false;
      this.certificateDetail = {};
    },
    closeDescriptionModal() {
      $("#certificate-description-modal").modal("hide");
      this.isDescriptionModalActive = false;
      this.descriptionDetail = {};
    },

    closeListingModal(){
      $("#useraddmodal").modal("hide");
      this.showUserListingModal = false
    },


    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        this.view(this.rowData);
        
      } else if (actionObj.title == this.$t("assign_trainings_to_user")) {
        this.certificate_id = rowData.id;
        this.showUserListingModal = true;
      } else if (actionObj.title == this.$t("apply")) {
        this.applyForCertificate(this.rowData);
      }
    },
    view(rowData) {
      this.certificateDetail = rowData;
      this.isViewModalActive = true;
    },
    openDescriptionModal(rowData) {
      this.descriptionDetail = rowData;
      this.isDescriptionModalActive = true;
    },
    bindDescriptionTrigger(triggerId, row) {
      setTimeout(() => {
        const trigger = document.getElementById(triggerId);
        if (trigger && !trigger.dataset.descriptionBound) {
          trigger.dataset.descriptionBound = "true";
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            this.openDescriptionModal(row);
          });
        }
      }, 0);
    },
    myFunction(row){
      let doc = document.getElementById(row.id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(row);
        }) 
      }
    },

    buyerCertificate(id) {
      this.input.id = id;
      axiosPost(actions.BUYER_CERTIFICATE_STORE, this.input)
        .then((res) => {
          if (res.data.type == "success") {
            this.$toastr.s(res.data.message);
            location.reload();
          } else if (res.data.type == "applied") {
            this.$toastr.w(res.data.message);
          } else {
            this.$toastr.e(res.data.message);
          }
        })
        .catch((error) => {
          this.$toastr.e(error);
        });
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          // this.searchAndSelectFilterOptions()
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    applyForCertificate(certificate) {
      let certificate_id = certificate.id;
      axiosPost(actions.BUYER_CERTIFICATE_APPLY, {
        certificate_id: certificate_id,
        type: certificate.type,
      })
        .then((res) => {
          let message = res.data.message;
          this.$toastr.s(message);
        })
        .catch((error) => {
          
        }).finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    // getPackages() {
    //   axiosGet(actions.ADMIN_CERTIFICATE)
    //     .then((res) => {
    //       this.packages = res.data.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    btnSubmit(id) {
      location.replace("/admin/stripePay/" + id);
    },
  },
};
</script>

<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
